import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    inputBeds: false,
    inputBaths: false,
    inputCars: false,
    inputLotSizeRange: [0, 10000],
    inputDwellingSizeRange: [0, 10000],
    inputPriceRange: [0, 10000],
    inputLotNumber: '',
    inputBuilder: '',
    inputColourScheme: '',
    inputHouseDesign: '',
    inputType: null,
    inputView: null,
  },

  getters: {
    inputBeds: (state) => state.inputBeds,
    inputType: (state) => state.inputType,
    inputView: (state) => state.inputView,
  },

  mutations: {
    SET_FILTER_PARAMETERS: (state, parameters) => {
      if (!_.isUndefined(parameters.inputBeds)) state.inputBeds = parameters.inputBeds
      if (!_.isUndefined(parameters.inputBaths)) state.inputBaths = parameters.inputBaths
      if (!_.isUndefined(parameters.inputCars)) state.inputCars = parameters.inputCars
      if (!_.isUndefined(parameters.inputLotSizeRange)) state.inputLotSizeRange = parameters.inputLotSizeRange
      if (!_.isUndefined(parameters.inputDwellingSizeRange)) state.inputDwellingSizeRange = parameters.inputDwellingSizeRange
      if (!_.isUndefined(parameters.inputPriceRange)) state.inputPriceRange = parameters.inputPriceRange
      if (!_.isUndefined(parameters.inputLotNumber)) state.inputLotNumber = parameters.inputLotNumber
      if (!_.isUndefined(parameters.inputBuilder)) state.inputBuilder = parameters.inputBuilder
      if (!_.isUndefined(parameters.inputColourScheme)) state.inputColourScheme = parameters.inputColourScheme
      if (!_.isUndefined(parameters.inputHouseDesign)) state.inputHouseDesign = parameters.inputHouseDesign
      if (!_.isUndefined(parameters.inputType)) state.inputType = parameters.inputType
      if (!_.isUndefined(parameters.inputView)) state.inputView = parameters.inputView
    },    

    RESET_FILTER_PARAMETERS: (state) => {
      state.inputBeds = false
      state.inputBaths = false
      state.inputCars = false
      state.inputLotSizeRange = [0, 10000]
      state.inputDwellingSizeRange = [0, 10000]
      state.inputPriceRange = [0, 10000]
      state.inputLotNumber = ''
      state.inputBuilder = ''
      state.inputColourScheme = ''
      state.inputHouseDesign = ''
      state.inputType = null
      state.inputView = null
    },
  },
}
